module.exports = __webpack_public_path__ + "img/Eintracht-Frankfurt.a47be4aa.png";